import {ActionMenuSection} from '#/components/actionmenu/types';
import {Layout} from '#/components/layout/layout';
import {Portfolio} from '#/components/portfolio/portfolio';
import {WalletContext} from '#/contexts/wallet-provider';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {Page} from '#/pages/page';
import {DefaultChildren} from '#/utils/utils';
import {Land, UnlistedLand} from '@shareland/shareland-common';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

export const PortfolioPage: FunctionComponent<DefaultChildren> = () => {
  const {t} = useTranslation('translation');

  const {
    accountResult: {address: account, isConnected},
  } = useContext(WalletContext);
  const {openLandOnMap} = useQueryNavigationActions();

  const onSearch = (land: Land | UnlistedLand) => {
    openLandOnMap(land, ActionMenuSection.TRADE);
  };

  return (
    <Page title={t('pages.portfolio.htmlTitle')}>
      <Layout bgColor='bg-gray-800' variant='fill' onSearch={onSearch}>
        {isConnected && account && <Portfolio account={account} isCurrentUser={true} />}
      </Layout>
    </Page>
  );
};
